import React, { useState } from 'react'
import MainContainer from '../../layout/MainContainer'
import { Box, Tab, Tabs } from '@mui/material';
import SearchBar from '../../components/SearchBar';
import CustomPagination from '../../components/CustomPagination';
import CancelTable from './cancelTable';
import FilterMenu from '../../components/filterMenu';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const categories = [
  "All",
  "Dining",
  "Event",
  "Experience",
  "Beach Clubs",
  "Benefits",
  "Wellness",
];

export const Cancellation = () => {

  // For first tab group (All, Dining, Events...)
  const [mainTab, setMainTab] = React.useState(0);

  // For second tab group (Pending Requests, Cancelled Requests)
  const [subTab, setSubTab] = React.useState(0);

  const handleChangeMainTab = (event: React.SyntheticEvent, newValue: number) => {
    setMainTab(newValue);
    setSubTab(0); // Reset sub-tab when main tab changes
  };

  const handleChangeSubTab = (event: React.SyntheticEvent, newValue: number) => {
    setSubTab(newValue);
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [searchTerm, setSearchTerm] = useState('');

  return (
    <MainContainer>

      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Cancellation Requests</h1>
        </div>

        <div className="right_s">

          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search status & membership"
              />
            </Box>
          </div>
          <div className="right_s">
            <FilterMenu />
          </div>
        </div>
      </div>

      {/* Main Tabs */}
      <Box className="custom_tabs2 mt_40 mb_30" sx={{ width: '100%' }}>
        <Tabs
          value={mainTab}
          onChange={handleChangeMainTab}
          aria-label="Main Tabs"
          className="custom_tabs_links"
        >
          <Tab label="All" {...a11yProps(0)} />
          <Tab label="Dining" {...a11yProps(1)} />
          <Tab label="Event" {...a11yProps(2)} />
          <Tab label="Experience" {...a11yProps(3)} />
          <Tab label="Beach Clubs" {...a11yProps(4)} />
          <Tab label="Benefits" {...a11yProps(5)} />
          <Tab label="Wellness" {...a11yProps(6)} />
        </Tabs>
      </Box>

      {/* Render Content for Each Main Tab */}
      <CustomTabPanel value={mainTab} index={0}>
        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: '100%' }}>
            <Tabs
              value={subTab}
              onChange={handleChangeSubTab}
              aria-label="Sub Tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending Requests" {...a11yProps(0)} />
              <Tab label="Cancelled Requests" {...a11yProps(1)} />
            </Tabs>
          </Box>

          {/* Sub Tabs Content */}
          <CustomTabPanel value={subTab} index={0}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>

          <CustomTabPanel value={subTab} index={1}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>
        </div>
        <CustomPagination />
      </CustomTabPanel>

         <CustomTabPanel value={mainTab} index={1}>
        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: '100%' }}>
            <Tabs
              value={subTab}
              onChange={handleChangeSubTab}
              aria-label="Sub Tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending Requests" {...a11yProps(0)} />
              <Tab label="Cancelled Requests" {...a11yProps(1)} />
            </Tabs>
          </Box>

          {/* Sub Tabs Content */}
          <CustomTabPanel value={subTab} index={0}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>

          <CustomTabPanel value={subTab} index={1}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>
        </div>
        <CustomPagination />
      </CustomTabPanel>

         <CustomTabPanel value={mainTab} index={2}>
        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: '100%' }}>
            <Tabs
              value={subTab}
              onChange={handleChangeSubTab}
              aria-label="Sub Tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending Requests" {...a11yProps(0)} />
              <Tab label="Cancelled Requests" {...a11yProps(1)} />
            </Tabs>
          </Box>

          {/* Sub Tabs Content */}
          <CustomTabPanel value={subTab} index={0}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>

          <CustomTabPanel value={subTab} index={1}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>
        </div>
        <CustomPagination />
      </CustomTabPanel>

         <CustomTabPanel value={mainTab} index={3}>
        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: '100%' }}>
            <Tabs
              value={subTab}
              onChange={handleChangeSubTab}
              aria-label="Sub Tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending Requests" {...a11yProps(0)} />
              <Tab label="Cancelled Requests" {...a11yProps(1)} />
            </Tabs>
          </Box>

          {/* Sub Tabs Content */}
          <CustomTabPanel value={subTab} index={0}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>

          <CustomTabPanel value={subTab} index={1}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>
        </div>
        <CustomPagination />
      </CustomTabPanel>


         <CustomTabPanel value={mainTab} index={4}>
        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: '100%' }}>
            <Tabs
              value={subTab}
              onChange={handleChangeSubTab}
              aria-label="Sub Tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending Requests" {...a11yProps(0)} />
              <Tab label="Cancelled Requests" {...a11yProps(1)} />
            </Tabs>
          </Box>

          {/* Sub Tabs Content */}
          <CustomTabPanel value={subTab} index={0}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>

          <CustomTabPanel value={subTab} index={1}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>
        </div>
        <CustomPagination />
      </CustomTabPanel>


         <CustomTabPanel value={mainTab} index={5}>
        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: '100%' }}>
            <Tabs
              value={subTab}
              onChange={handleChangeSubTab}
              aria-label="Sub Tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending Requests" {...a11yProps(0)} />
              <Tab label="Cancelled Requests" {...a11yProps(1)} />
            </Tabs>
          </Box>

          {/* Sub Tabs Content */}
          <CustomTabPanel value={subTab} index={0}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>

          <CustomTabPanel value={subTab} index={1}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>
        </div>
        <CustomPagination />
      </CustomTabPanel>


         <CustomTabPanel value={mainTab} index={6}>
        <div className="cards table_cards v2">
          <Box className="custom_tabs" sx={{ width: '100%' }}>
            <Tabs
              value={subTab}
              onChange={handleChangeSubTab}
              aria-label="Sub Tabs"
              className="custom_tabs_links"
            >
              <Tab label="Pending Requests" {...a11yProps(0)} />
              <Tab label="Cancelled Requests" {...a11yProps(1)} />
            </Tabs>
          </Box>

          {/* Sub Tabs Content */}
          <CustomTabPanel value={subTab} index={0}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>

          <CustomTabPanel value={subTab} index={1}>
            <CancelTable actionType="quick" category={categories[mainTab]} />
          </CustomTabPanel>
        </div>
        <CustomPagination />
      </CustomTabPanel>

    

    </MainContainer>
  )
}

export default Cancellation;
